import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Stack } from "@mui/system";
import Icon from "../../../designSystem/atoms/Icon";
import Separator from "../../../designSystem/atoms/Separator";
import Typography from "../../../designSystem/atoms/Typography";
import PfSwitchCard, {
  PF_SWITCH_TYPE,
} from "../../Portfolio/PfSwitchCard/PfSwitchCard";
import { isEmpty } from "lodash-es";
import { getConfig } from "../../../utils/functions";
import OrderDetailsFooter from "../OrderDetailsFooter";

import "./SwitchOrderDetails.scss";

import { ORDER_DETAILS } from "businesslogic/strings/ordersAuth";
const STRINGS = ORDER_DETAILS.switchCard;

const SwitchOrderDetails = ({
  topLabel,
  bottomLabel,
  topTitle,
  bottomTitle,
  topIcon,
  bottomIcon,
  tags,
  totalUnits,
  amount,
  footerProps,
}) => {
  const { productName } = useMemo(getConfig, [])
  return (
    <Stack className="oa-switch-card">
      <SwitchCardTopSection
        label={topLabel}
        title={topTitle}
        icon={topIcon}
        totalUnits={totalUnits}
        amount={amount}
      />
      <Separator sx={{ backgroundColor: "transparent" }} dataAid={1}>
        <Icon
          src={require(`assets/${productName}/switch_icon.svg`)}
          width="40px"
          height="40px"
          dataAid="switch"
        />
      </Separator>
      <PfSwitchCard
        variant={PF_SWITCH_TYPE.DETAIL}
        label={bottomLabel}
        title={bottomTitle}
        tags={tags}
        middleImgSrc={bottomIcon}
        containerSx={{ marginBottom: "16px" }}
        hideBottomRow
      />
      {!isEmpty(footerProps) && (
        <>
          <Separator dataAid={1} />
          <OrderDetailsFooter {...footerProps} />
        </>
      )}
    </Stack>
  );
};

const SwitchCardTopSection = ({ label, title, icon, totalUnits, amount }) => (
  <Stack className="top-section">
    <Typography
      variant="body5"
      dataAid={STRINGS.fundName.dataAid}
      color={"foundationColors.content.secondary"}
    >
      {label}
    </Typography>
    <Stack className="top-content">
      <Icon src={icon} size="32px" dataAid="left" />
      <Typography
        variant="body1"
        dataAid="title"
        sx={{ marginLeft: "8px" }}
        color={"foundationColors.content.primary"}
      >
        {title}
      </Typography>
    </Stack>
    <Stack className="details">
      {totalUnits ? (
        <Box>
          <Typography
            variant="body5"
            color={"foundationColors.content.secondary"}
            dataAid={STRINGS.totalUnitsKey.dataAid}
          >
            {STRINGS.totalUnitsKey.text}
          </Typography>
          <Typography
            variant="body2"
            color={"foundationColors.content.primary"}
            dataAid={STRINGS.totalUnitsValue.dataAid}
          >
            {totalUnits}
          </Typography>
        </Box>
      ) : null}
      <Box>
        <Typography
          variant="body5"
          color={"foundationColors.content.secondary"}
          dataAid={STRINGS.switchableAmountKey.dataAid}
        >
          {STRINGS.switchableAmountKey.text}
        </Typography>
        <Typography
          variant="body2"
          color={"foundationColors.content.primary"}
          dataAid={STRINGS.switchableAmountValue.dataAid}
        >
          {amount}
        </Typography>
      </Box>
    </Stack>
  </Stack>
);

SwitchOrderDetails.defaultProps = {
  tags: [],
};

SwitchOrderDetails.propTypes = {
  topLabel: PropTypes.string,
  bottomLabel: PropTypes.string,
  topTitle: PropTypes.string,
  bottomTitle: PropTypes.string,
  topIcon: PropTypes.string,
  bottomIcon: PropTypes.string,
  tags: PropTypes.array,
  totalUnits: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.bool] ),
  amount: PropTypes.string,
  noFooter: PropTypes.bool,
  footerProps: PropTypes.object,
};

export default SwitchOrderDetails;
